<template>
  <div class="invoice">
    <div class="invoice__row">
      <h2>{{ subtype }} {{ doc.name }}</h2>
      <span>{{ doc.creation_date | formatDateShort }}</span>
    </div>
    <span>{{ doc[doc.subtype === 1 || doc.subtype === 3 ? 'from' : 'to'].name }}</span>
    <div class="invoice__row">
      <div class="invoice__row">
        <div class="invoice__tag" v-for="(tag, i) in tags" :key="'tag' + i">{{ tag }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getWarehouseDocType } from '@/utils/warehouseDocType'

export default {
  props: {
    doc: Object,
  },
  computed: {
    tags() {
      return this.doc.tags ? this.doc.tags.split(',') : []
    },
    subtype() {
      return getWarehouseDocType(this.doc.subtype)
    },
  },
}
</script>

<style lang="scss" scoped>
.invoice {
  width: 90%;
  margin: 4px auto;
  transition: 0.3s;
  padding: 8px;
  border-radius: 8px;

  &:hover,
  &:focus {
    background-color: #f8f8f8;
  }

  &__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__tag {
    display: inline-block;
    text-transform: uppercase;
    padding: 3px 6px;
    margin: 0 3px;
    box-shadow: 0 0 4px $primaryColor;
    font-size: 9px;
    border-radius: 12px;
  }

  h2 {
    margin: 0;
    font-size: 14px;
    font-weight: $bold;
    color: #333;
  }

  span {
    font-weight: $normal;
    color: #888;
    font-size: 14px;
  }

  .income {
    color: $primaryColor;

    &::before {
      content: '+ ';
    }
  }

  .outcome {
    color: #ff6584;

    &::before {
      content: '- ';
    }
  }
}
</style>
